import { createThemeStore, FAMILY_THEME_CONFIG, type ThemeConfig } from "@jkast90/kast-common/theme";

/** The family's System, Light, Dark and High contrast, saved per browser under the key it has always had. */
export const themeConfig: ThemeConfig = { storageKey: "salvagers_theme", ...FAMILY_THEME_CONFIG };

export const themeStore = createThemeStore(themeConfig);
